/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : softwareIntersectionActions.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";
const softwareIntersectionAPI = {
  get_software_intersections: {
    api_name: "/VLC/swm/intersections",
    https_method: "GET",
    action_type: actionType.GET_SOFTWARE_INTERSECTIONS,
    description: "Get the Software Intersections",
  },
  get_software_legal_requirements: {
    api_name: "/VLC/swm/legal-requirements",
    https_method: "GET",
    action_type: actionType.GET_SOFTWARE_LR,
    description: "Get the Software LR",
  },
  get_ee_legal_requirements: {
    api_name: "/VLC/ee_components/legal-requirements",
    https_method: "GET",
    action_type: "",
    description: "",
  },
  get_vs_legal_requirements: {
    api_name: "/VLC/vehicle_systems/legal-requirements",
    https_method: "GET",
    action_type: "",
    description: "Get vehicle system legal requirements",
  },
  get_vc_legal_requirements: {
    api_name: "/VLC/vehicle_components/legal-requirements",
    https_method: "GET",
    action_type: "",
    description: "Get vehicle component legal requirements",
  },
  get_ee_for_legal_requirements: {
    api_name: "/ACM/lr-intersections/getEEForLegalRequirements",
    https_method: "GET",
    action_type: "",
    description: "Get EE for legal requirements",
  },
  get_swm_for_legal_requirements: {
    api_name: "/ACM/lr-intersections/getSWMForLegalRequirements",
    https_method: "GET",
    action_type: "",
    description: "Get SWM for legal requirements",
  },
  get_vs_for_legal_requirements: {
    api_name: "/ACM/lr-intersections/getVSForLegalRequirements",
    https_method: "GET",
    action_type: "",
    description: "Get VS for legal requirements",
  },
  get_vc_for_legal_requirements: {
    api_name: "/ACM/lr-intersections/getVCForLegalRequirements",
    https_method: "GET",
    action_type: "",
    description: "Get VC for legal requirements",
  },
};
export default softwareIntersectionAPI;
